import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const DateContainer = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "10px",
});
